// extracted by mini-css-extract-plugin
export default {"container":"WorkData_container__JniTk","row":"WorkData_row__exi8l","myAutocomplete":"WorkData_myAutocomplete__oUGBB"};